module.exports = __webpack_public_path__ + "img/360_background.41018210.png";